/**
 * Where pdf.js's image DECODERS are served from: `jbig2.wasm` (JBIG2 — what office scanners use
 * for black-and-white pages), `openjpeg.wasm` (JPEG 2000), `qcms_bg.wasm` (colour profiles) and
 * their no-wasm fallbacks, copied verbatim from `pdfjs-dist/wasm/` into `public/pdfjs/`.
 *
 * Without `wasmUrl`, pdf.js cannot load them, logs "Jbig2Error: JBig2 failed to initialize" and
 * DROPS every such image — a scanned settlement statement renders as its blank form lines only.
 * `tests/frontend/utils/pdfjs-wasm-assets.spec.ts` fails if the copies drift from the
 * installed pdfjs-dist (re-copy them after an upgrade).
 *
 * Lives apart from `pdfjs-loader.web.ts` so the native loader stub can share it without
 * importing pdf.js.
 */
export const PDFJS_WASM_URL = '/pdfjs/';

/** `getDocument` parameters every renderer must use, so no caller can forget the decoders. */
export const pdfDocumentParams = (url: string): { url: string; wasmUrl: string } => ({ url, wasmUrl: PDFJS_WASM_URL });
